// Collections
export const NOTIFICATIONS_COLLECTION = 'notifications';
export const UNREAD_HORSE_NOTIFICATIONS_USER_SUBCOLLECTION = 'unreadHorses';

// Recordings notifications const types
export const NEW_RECORDING_RESULT_EVENT_TYPE = 'newRecordingResult';
export const RECORDING_RESOURCE_TYPE = 'recordings';

export const NOTIFICATIONS_IN_QUERY_CHUNK_SIZE = 30;

